module.exports = __webpack_public_path__ + "img/product-1-back-MOBILE.a5a7cd92.png";